import { useSiteSettings } from "@/lib/siteSettings";

/**
 * A mood photo chosen in Admin > Settings > Mood images. Renders nothing when
 * the slot is empty. While images are marked illustrative (AI or stock), a
 * small note says so: shoppers should never mistake them for our farm or jar.
 */
export default function MoodImage({ slot, alt, className = "", imgClassName = "", caption = true }) {
  const s = useSiteSettings();
  const src = s?.mood_images?.[slot];
  if (!src) return null;
  const illustrative = s?.mood_images_illustrative !== false;
  return (
    <figure className={`relative ${className}`}>
      <img src={src} alt={alt} loading="lazy" decoding="async" className={`w-full h-full object-cover ${imgClassName}`} />
      {caption && illustrative && (
        <figcaption className="absolute bottom-2 right-3 rounded-full bg-black/45 px-2.5 py-0.5 font-body text-[11px] text-white/85">Illustrative image</figcaption>
      )}
    </figure>
  );
}
